/**
 * Five-star control: hover previews fill; click saves via onRate(stars).
 */
import React, { useState } from 'react';

export function RecipeStarsInput({ value, onRate, disabled = false }) {
  const [hover, setHover] = useState(null);
  const display = hover != null ? hover : (value ?? 0);

  return (
    <span
      className="recipe-stars-input d-inline-flex align-items-center gap-0"
      role="group"
      aria-label="Your rating"
      onMouseLeave={() => setHover(null)}
    >
      {[1, 2, 3, 4, 5].map((s) => (
        <button
          key={s}
          type="button"
          disabled={disabled}
          className={`recipe-stars-input__btn ${s <= display ? 'is-on' : ''}`}
          aria-label={`${s} star${s === 1 ? '' : 's'}`}
          aria-pressed={value === s}
          onMouseEnter={() => setHover(s)}
          onFocus={() => setHover(s)}
          onBlur={() => setHover(null)}
          onClick={() => onRate(s)}
        >
          {s <= display ? '★' : '☆'}
        </button>
      ))}
    </span>
  );
}
